import { Mark } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { link } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/link.js';

/* eslint-disable */
class Link extends Mark {
  get name() {
    return 'link';
  }

  get schema() {
    return link;
  }

}

export default Link;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/marks/Link.js